import { useTheme } from "./ThemeProvider";

/**
 * Returns the nearest `ThemeProvider` wrapper element so portaled content
 * (Drawer, Modal, Tooltip, Popover, DatePicker, ...) can render inside the
 * provider's themed subtree.
 *
 * Returns `undefined` (not `null`) when no provider is mounted yet or when
 * called outside a `ThemeProvider`, so the value composes cleanly with the
 * Radix / Floating UI portal APIs, which treat `undefined` as "use default"
 * (i.e. `document.body`).
 */
export const useThemePortalContainer = (): HTMLElement | undefined => {
  const { portalContainer } = useTheme();
  return portalContainer ?? undefined;
};
